import 'common/prototype/array.prototype';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';

import { AppFormModule } from './app-form/app-form.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AttendanceFormModule } from './attendance-form/attendance-form.module';
import { AttendanceFormCanDeactivateGuard } from './attendance-form/attendance-form-leave.gurad';
import { QuestionnaireFormModule } from './questionnaire-form/questionnaire-form.module';
import { RedirectPageComponent } from './redirect-page/redirect-page.component';
import { SuccessPageComponent } from './success-page/success-page.component';
import { SharedModule } from './shared/shared.module';
import { RedirectFormService } from './services/redirect-form.service';

@NgModule({
  declarations: [
    AppComponent,
    SuccessPageComponent,
    RedirectPageComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    AppFormModule,
    AttendanceFormModule,
    QuestionnaireFormModule,
    ToastrModule.forRoot(),
    SharedModule
  ],
  providers: [AttendanceFormCanDeactivateGuard, RedirectFormService],
  bootstrap: [AppComponent]
})
export class AppModule { }
